<template>
    <div>
        <template v-if="list.length > 0">
            <div class="item" v-for="(item,index) in list" :key="index">
                <div>
                    <img :src="loadWarningImg(item.code,item.level)" />
                </div>
                <div>
                    <span>{{item.title}}</span>
                    <p>{{item.content}}</p>
                </div>
            </div>
        </template>
        <div v-if="list.length == 0" class="noContent">当前无预警</div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            list: [
                // {
                //     code: "11B03",
                //     level: "blue",
                //     title: "暴雨蓝色预警",
                //     content: "乌鲁木齐市气象局4月27日发布暴雨蓝色预警：是v分四十三的出租屋地区发生的现场测试，给对方方式发送旅客附件，收到付款时间东风科技，的封建时代JFK入境对方，是风力风速劳动法陌生地方为发射点发生。"
                // },
            ]
        };
    },
    mounted(){
        this.loadData();
    },
    methods: {
        loadWarningImg(code, level) {
            return require(`../assets/warning/big_${code}_${level}.png`);
        },

        loadData(){
            this.ajax('wxInterface/warnQuery',{},data => {
                if(data != null){
                    this.list = data;
                }
            });
        },
    }
};
</script>

<style lang="less" scoped>
.item {
    display: flex;
    align-items: center;
    color: white;
    background-color: rgba(0, 0, 0, 0.3);
    > div {
        &:first-child {
            flex: 1;
            > img {
                width: 100%;
            }
        }
        &:last-child {
            flex: 3;
            padding: 5px 10px;

            > span {
                font-size: large;
            }
            > p {
                font-size: smaller;
                color: rgba(255, 255, 255, 0.8);
                margin: 5px 0;
            }
        }
    }
    + .item {
        border-top: 1px solid rgba(255, 255, 255, 0.7);
    }
}
</style>